import InfoModal from "../infoModal";

import { GEOS_contract, LP_contract } from "../../Constants.js";

const CONTRACT_POLYSCAN_URL = `https://polygonscan.com/address/${LP_contract.address}`;
const QUICKSWAP_URL = `https://quickswap.exchange/#/add/0xc2132D05D31c914a87C6611C10748AEb04B58e8F/${GEOS_contract.address}`;

const InfoLPModal = ({ displayModal, setDisplayModal }) => {
  const getWeightText = () => (
    <>
      This core pool GEO$/USDT LP tokens, and is configured with a
      <span className="purple"> weight of 0.72 </span>for receiving rewards.
    </>
  );

  const getAcquireText = () => (
    <>
      You can acquire GEO$/USDT LP tokens at
      <a href={QUICKSWAP_URL} target="_blank" rel="noopener noreferrer">
        <span className="purple"> QuickSwap.exchange</span>
      </a>
      , by providing liquidity in the GEO$/USDT pool.
    </>
  );

  const getFooterLabel = () => (
    <>
      For more information on all the pools available, governance, liquidity
      mining, and vault distributions, please visit the
      <a>
        <span> Staking FAQ </span>
      </a>
      on our website
    </>
  );

  return (
    <InfoModal
      title="GEO$/USDT"
      weightText={getWeightText()}
      viewPoolContractURL={CONTRACT_POLYSCAN_URL}
      acquireText={getAcquireText()}
      footerLabel={getFooterLabel()}
      displayModal={displayModal}
      setDisplayModal={setDisplayModal}
    />
  );
};

export default InfoLPModal;
